var map = {
  "./cs.json": [
    "RS",
    [
      "z2p"
    ]
  ],
  "./en.json": [
    "fm",
    [
      "ta"
    ]
  ],
  "./pl.json": [
    "m0v",
    [
      "8bk"
    ]
  ],
  "./tr.json": [
    "pS",
    [
      "rng"
    ]
  ],
  "./zh.json": [
    "Jg",
    [
      "f5f"
    ]
  ],
  "./ja.json": [
    "t6",
    [
      "jw"
    ]
  ],
  "./pt-br.json": [
    "RrV",
    [
      "3h"
    ]
  ],
  "./de.json": [
    "cO",
    [
      "2s"
    ]
  ],
  "./es.json": [
    "IbE",
    [
      "yx"
    ]
  ],
  "./fr.json": [
    "PW",
    [
      "5xc"
    ]
  ],
  "./ko.json": [
    "Pyu",
    [
      "xm"
    ]
  ],
  "./pt.json": [
    "xV4",
    [
      "nn6"
    ]
  ],
  "./ru.json": [
    "KR",
    [
      "06z"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "uN";
module.exports = __rspack_async_context;
